export default [
  { value: "I", label: "I" },
  { value: "II", label: "II" },
  { value: "III", label: "III" },
  { value: "IV", label: "IV" },
  { value: "Jr", label: "Jr" },
  { value: "Sr", label: "Sr" },
  { value: "V", label: "V" },
  { value: "VI", label: "VI" },
];
